import { gql } from '@apollo/client';
export const UPDATE_MEETING_PARTICIPATION_STATUS = gql(`mutation updateMeetingParticipationStatus($meeting_participant_id: Int, $status: String) {
    sch_update_meeting_participant_status(meeting_participant_id: $meeting_participant_id, status: $status){
      data
      success
     error_message
    }
  }
`);
export const GET_LEGACY_LIVE_SESSION = gql `
  query frm_legacy_live_session($id: bigint!) {
    frm_legacy_live_session(id: $id) {
      assessment_section_candidate {
        assessment_section {
          section {
            external_id
          }
        }
      }
    }
  }
`;
